<template>
  <iColumn gap="none" overflow="scroll">
    <iColumn
      v-if="items.length === 0"
      height="hug"
      width="fill"
      :style-overrides="{paddingLeft: 'small'}"
    >
      <iText
        font-size="small"
        variant="subtle"
      >
        {{ emptyText }}
      </iText>
    </iColumn>
    <!-- Sortable mode -->
    <iSortable
      v-else-if="sortable"
      :model-value="items"
      :index-key="idKey || undefined"
      @update:model-value="$emit('update:items', $event)"
    >
      <template #handle>
        <iIcon name="formkit:draghandle" size="small" />
      </template>
      <template #draggable-item="{menuItem: item, index}">
        <ListConfigRowItem
          :item-key="getItemKey(item, index)"
          :label="getLabel(item, getItemKey(item, index))"
          :icon="icon"
          :currently-selected-id="currentlySelectedId"
          :is-invalid="getIsInvalid ? getIsInvalid(item, getItemKey(item, index)) : false"
          :is-editing="editingItemKey !== null && editingItemKey == getItemKey(item, index)"
          @select="$emit('select:item', item, getItemKey(item, index))"
          @rename="$emit('rename:item', getItemKey(item, index), $event)"
        />
      </template>
    </iSortable>

    <!-- Static mode -->
    <template v-else>
      <ListConfigRowItem
        v-for="(item, index) in items"
        :key="getItemKey(item, index)"
        :item-key="getItemKey(item, index)"
        :label="getLabel(item, getItemKey(item, index))"
        :icon="icon"
        :currently-selected-id="currentlySelectedId"
        :is-invalid="getIsInvalid ? getIsInvalid(item, getItemKey(item, index)) : false"
        :is-editing="editingItemKey !== null && editingItemKey == getItemKey(item, index)"
        @select="$emit('select:item', item, getItemKey(item, index))"
        @rename="$emit('rename:item', getItemKey(item, index), $event)"
      />
    </template>
  </iColumn>
</template>

<script>
import ListConfigRowItem from "@/components/create-dashboard/ListConfigPanelRowItem.vue";

export default {
  name: "ListConfigPanel",
  components: { ListConfigRowItem },
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    itemKeys: {
      type: Array,
      required: false,
      default: () => [],
    },
    idKey: {
      type: String,
      required: false,
      default: "",
    },
    currentlySelectedId: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    icon: {
      type: String,
      required: false,
      default: "",
    },
    getLabel: {
      type: Function,
      required: true,
    },
    getIsInvalid: {
      type: Function,
      required: false,
      default: null,
    },
    emptyText: {
      type: String,
      required: false,
      default: "No Items",
    },
    sortable: {
      type: Boolean,
      required: false,
      default: false,
    },
    editingItemKey: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  emits: ["select:item", "update:items", "rename:item"],
  methods: {
    getItemKey(item, index) {
      if (this.idKey && item[this.idKey]) {
        return item[this.idKey];
      }
      if (this.itemKeys && this.itemKeys[index]) {
        return this.itemKeys[index];
      }
      return index;
    },
  },
};
</script>
